import React from 'react';
import { AdditionalType, Tourney } from '../../../model/interfaces';
import { PendingTournamentInfo } from './pendingTournamentInfo/pendingTournamentInfo';
import PendingTournamentTabs from './pendingTournamentTabs/pendingTournamentTabs';

export default function PendingTournamentAdditional(props: {
  data: AdditionalType;
  tournament: Tourney
}) {

  return (
    <div className="pending-additional">
      <PendingTournamentInfo info={props.data} />
      <PendingTournamentTabs tournament={props.tournament}/>
    </div>
  );
};
